import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { AppContext } from "../common/AppContext";
import { SettingsCourseList } from "../data/settings/SettingCourseList";

type Props = {
  params: Record<string, string | number>;
};

const useGetTrainingsWithPaging = ({ params }: Props) => {
  const context = useContext(AppContext);

  const { data: trainings, ...rest } = useQuery({
    queryKey: ["GET_TRAININGS", params],
    queryFn: () => SettingsCourseList.getWithPaging(context, params),
    select: (res: any) => res.courses,
    enabled: !!params.integrationId
  });

  return {
    trainings,
    ...rest
  };
};

export default useGetTrainingsWithPaging;
